import { useState } from 'react'
import { Button } from "../../Components/Helper"
import TextAreaField from '../../ReusableComponents/TextAreaInput';
import Popup from '../../ReusableFunctions/Popup';
import { useLocation, useNavigate } from 'react-router';
import { addFeedPost } from '../../apis/adminAPIs/Feeds';
import { PDRL_ADMIN_ROUTES } from '../../routes';


const CreateNewFeed = () => {
  const [image, setImage] = useState(null)
  const [imagePreview, setImagePreview] = useState(null)
  const location = useLocation();
  const { post } = location.state || {}
  const [postDescriptions, setPostDescriptions] = useState({
    English: { title: "", description: "" },
    Hindi: { title: "", description: "" },
    Marathi: { title: "", description: "" },
    Punjabi: { title: "", description: "" },
    Kannada: { title: "", description: "" },
    Gujarati: { title: "", description: "" },
    Tamil: { title: "", description: "" },
    Telugu: { title: "", description: "" },
    Malayalam: { title: "", description: "" }
  })
  const [error, setError] = useState({
    Hindi: { title: "", description: "" },
    Marathi: { title: "", description: "" },
    Punjabi: { title: "", description: "" },
    Kannada: { title: "", description: "" },
    Gujarati: { title: "", description: "" },
    Tamil: { title: "", description: "" },
    Telugu: { title: "", description: "" },
    English: { title: "", description: "" },
    Malayalam: { title: "", description: "" }
  })
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate();
  let  acceptfiles =["image/jpeg","image/png","image/jpg"];
  const handleImageChange = (e) => {
    const file = e.target.files?.[0]
     
    if (file) {
      if(!acceptfiles.includes(file?.type)){
        Popup.alert("Error", "Please upload png/jpeg type image", 'ERROR')
        setImage(() => null)
        setImagePreview(() => null)
        e.target.value=null;
        return ;
      }
      if (file.size > 10 * 1024 * 1024 ) {  //allow 10MB large file
        Popup.alert("Error", "upload the image upto 10MB", 'ERROR')
        setImage(() => null)
        setImagePreview(() => null)
        e.target.value=null;
       } else if(file.size < 50 * 1024 ){
        Popup.alert("Error", "upload the file greater than 50KB", 'ERROR')
        setImage(() => null)
        setImagePreview(() => null)
        e.target.value=null;
       }else  {
        setImage(file)
        const reader = new FileReader()
        reader.onloadend = () => {
          setImagePreview(reader.result)
        }
        reader.readAsDataURL(file)
      }
    }
  }
const handleInputChange = (e, type) => {
  const { name, value } = e.target;
  const trimmedValue = value.trim();

  setPostDescriptions((prev) => ({
    ...prev,
    [name]: {
      ...prev[name],
      [type]: value,
    },
  }));

  // Clear error for the current field if it's valid
  let currentFieldError = "";
  if (type === "description" && value.length > 400) {
    currentFieldError = "Description must not exceed 400 characters.";
  } else if (type === "title" && value.length > 100) {
    currentFieldError = "Title must not exceed 100 characters.";
  } else if (type === "description" && value.length < 5 && value !== "") {
    currentFieldError = "Description must be at least 5 characters long.";
  } else if (type === "title" && value.length < 3 && value !== "") {
    currentFieldError = "Title must be at least 3 characters long.";
  } else if (trimmedValue === "" && value.length >0) {
    currentFieldError = `${type.charAt(0).toUpperCase() + type.slice(1)} cannot be empty or spaces only.`;
  }

  // Check if the other field is empty
  const otherType = type === "title" ? "description" : "title";
  const otherValue = postDescriptions[name][otherType];
  let otherFieldError = "";
  if (value !== "" && otherValue.trim() === "") {
    otherFieldError = `${otherType.charAt(0).toUpperCase() + otherType.slice(1)} is required when ${type} is provided.`;
  }

  setError((prev) => ({
    ...prev,
    [name]: {
      ...prev[name],
      [type]: currentFieldError,
      [otherType]: otherFieldError,
    },
  }));
};

  const isEveryFieldFilled = () => {
    const isEnglishFilled = postDescriptions?.English?.description !== "" && postDescriptions?.English?.title !== ""
    const isEveryLanguageValid = Object.values(postDescriptions).every(
      (value) => (value.description !== "" && value.title !== "") || (value.description === "" && value.title === ""),
    )
    const hasErrors = Object.values(error).some((err) => err.description !== "" || err.title !== "")
    return isEnglishFilled && isEveryLanguageValid && !hasErrors && image
  }


  const handleFeedAdd = async (e) => {
    try {
      e.preventDefault()
      const formData = new FormData();
      formData.append('postImage', image);
      formData.append('texts', JSON.stringify(postDescriptions));
      setLoading(true);
      await addFeedPost(formData);
      setLoading(false);
      Popup.alert("SUCCESS",'Post added successfully',"SUCCESS",()=>{
        navigate(PDRL_ADMIN_ROUTES.FEEDS)
      });
    } catch (err) {
      // setLoading(false);
      console.log(err)
      alert(err)
    }

    // Reset form or show success message
  }


  return (
    <div className="max-w-full  px-14 py-8">
      <h1 className="text-2xl font-bold mb-4">Create New Post</h1>
      <form onSubmit={handleFeedAdd} className="space-y-4">
        <div className='flex w-full gap-4  '>
          <div className='flex flex-col w-[20%]  '>
            <div>
              <label htmlFor="image-upload" className="block text-sm font-medium text-gray-700 mb-2">
                Upload Image
              </label>
              <input
                id="image-upload"
                type="file"
                accept="image/jpeg, image/png"
                onChange={handleImageChange}
                className="block w-full text-sm text-gray-500
            file:mr-4 file:py-2 file:px-4
            file:rounded-full file:border-0
            file:text-sm file:font-semibold
            file:bg-violet-50 file:text-violet-700
            hover:file:bg-violet-100"
              />
            </div>
            {imagePreview && (
              <div className="mt-4">
                <img src={imagePreview || "/placeholder.svg"} alt="Preview" className="max-w-full h-[300px] rounded-lg shadow-md" />
              </div>
            )}
          </div>
          <div className='w-[80%] max-w-[80%] flex flex-col gap-1  '>
            <p>Description</p>
            <div className='grid grid-cols-3 gap-y-8 gap-x-8'>
              <div className='flex flex-col gap-2'>
                <label>English <span className='text-red-500 ml-1'>*</span></label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
            py-1 px-3 outline-none focus:outline-none border 
            border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="English"
                    placeholder='Enter title in English'
                    value={postDescriptions?.English?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.English?.title && <div className='text-[12px] text-red-500'>{error?.English?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.English.description}
                  name={"English"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in english`}
                  error={error.English?.description}
                  height={"100px"}
                />
              </div>
              <div className='flex flex-col gap-2'>
                <label>Hindi </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
            py-1 px-3 outline-none focus:outline-none border 
            border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Hindi"
                    placeholder='Enter title in Hindi'
                    value={postDescriptions?.Hindi?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Hindi?.title && <div className='text-[12px] text-red-500'>{error?.Hindi?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Hindi.description}
                  name={"Hindi"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Hindi`}
                  error={error.Hindi?.description}
                  height={"100px"}
                />
              </div>

              <div className='flex flex-col gap-2'>
                <label>Marathi </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
            py-1 px-3 outline-none focus:outline-none border 
            border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Marathi"
                    placeholder='Enter title in Marathi'
                    value={postDescriptions?.Marathi?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Marathi?.title && <div className='text-[12px] text-red-500'>{error?.Marathi?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Marathi.description}
                  name={"Marathi"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Marathi`}
                  error={error.Marathi?.description}
                  height={"100px"}
                />
              </div>

             <div className='flex flex-col gap-2'>
                <label>Punjabi </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
            py-1 px-3 outline-none focus:outline-none border 
            border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Punjabi"
                    placeholder='Enter title in Punjabi'
                    value={postDescriptions?.Punjabi?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Punjabi?.title && <div className='text-[12px] text-red-500'>{error?.Punjabi?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Punjabi.description}
                  name={"Punjabi"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Punjabi`}
                  error={error.Punjabi?.description}
                  height={"100px"}
                />
              </div>

              <div className='flex flex-col gap-2'>
                <label>Kannada </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
            py-1 px-3 outline-none focus:outline-none border 
            border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Kannada"
                    placeholder='Enter title in Kannada'
                    value={postDescriptions?.Kannada?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Kannada?.title && <div className='text-[12px] text-red-500'>{error?.Kannada?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Kannada.description}
                  name={"Kannada"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Kannada`}
                  error={error.Kannada?.description}
                  height={"100px"}
                />
              </div>

              <div className='flex flex-col gap-2'>
                <label>Gujarati </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
                    py-1 px-3 outline-none focus:outline-none border 
                    border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Gujarati"
                    placeholder='Enter title in Gujarati'
                    value={postDescriptions?.Gujarati?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Gujarati?.title && <div className='text-[12px] text-red-500'>{error?.Gujarati?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Gujarati.description}
                  name={"Gujarati"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Gujarati`}
                  error={error.Gujarati?.description}
                  height={"100px"}
                />
              </div>

              <div className='flex flex-col gap-2'>
                <label>Tamil </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
                    py-1 px-3 outline-none focus:outline-none border 
                    border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Tamil"
                    placeholder='Enter title in Tamil'
                    value={postDescriptions?.Tamil?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Tamil?.title && <div className='text-[12px] text-red-500'>{error?.Tamil?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Tamil.description}
                  name={"Tamil"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Tamil`}
                  error={error.Tamil?.description}
                  height={"100px"}
                />
              </div>

              <div className='flex flex-col gap-2'>
                <label>Telugu </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
                    py-1 px-3 outline-none focus:outline-none border 
                    border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Telugu"
                    placeholder='Enter title in Telugu'
                    value={postDescriptions?.Telugu?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Telugu?.title && <div className='text-[12px] text-red-500'>{error?.Telugu?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Telugu.description}
                  name={"Telugu"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Telugu`}
                  error={error.Telugu?.description}
                  height={"100px"}
                />
              </div>

              <div className='flex flex-col gap-2'>
                <label>Malayalam </label>
                <div className=''>
                  <input
                    className='w-full text-sm bg-[#F3F3F3] h-[30px] 
                    py-1 px-3 outline-none focus:outline-none border 
                    border-solid border-[#bfc8d9] placeholder:text-sm'
                    type='text'
                    name="Malayalam"
                    placeholder='Enter title in Malayalam'
                    value={postDescriptions?.Malayalam?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                  />
                  {error.Malayalam?.title && <div className='text-[12px] text-red-500'>{error?.Malayalam?.title}</div>}
                </div>
                <TextAreaField
                  value={postDescriptions.Malayalam.description}
                  name={"Malayalam"}
                  onChange={(e) => handleInputChange(e, "description")}
                  placeholder={`Enter message in Malayalam`}
                  error={error.Malayalam?.description}
                  height={"100px"}
                />
              </div>

            </div>
            <div className='mt-20 flex w-full justify-end'>
              <Button
                type="submit"
                text={loading?"Adding...":"Add"}
                isDisabled={!isEveryFieldFilled()|| loading}
                style={{ height: "35px", width: "90px", backgroundColor: "" }}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}


export default CreateNewFeed;